import { selector } from 'recoil';

import { myCollectionFiltersState, myCollectionsState } from '../atoms';

export const myFilteredCollectionsState = selector({
	key: 'myFilteredCollectionsState',
	get: ({ get }) => {
		let myCollections = get(myCollectionsState);
		const canisterId = get(myCollectionFiltersState);

		if (canisterId) {
			myCollections = myCollections.filter(collection => collection.canisterId === canisterId);
		}

		return myCollections;
	}
});
